<div class="toolbar-content" [class.is-disabled]="disabled()">
  <ng-content select="slot-toolbar-left, [slot='toolbar-left']"></ng-content>
  <ng-content
    select="slot-toolbar-middle, [slot='toolbar-middle']"
  ></ng-content>
  <ng-content select="slot-toolbar-right, [slot='toolbar-right']"></ng-content>
</div>
